import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { FilesAmountStyled, SectionInfoStyled, TitleStyled, TotalFilesLabelStyled } from './styles';

interface TableInfoBarProps extends ICustomizableElement {
  title: string;
  rightContent?: React.ReactNode;
}

interface TotalFilesLabelProps {
  filesAmount: number;
}

export const TotalFilesLabel: React.FC<TotalFilesLabelProps> = ({ filesAmount }) => {
  return (
    <TotalFilesLabelStyled>
      Total Files: <FilesAmountStyled>{filesAmount}</FilesAmountStyled>
    </TotalFilesLabelStyled>
  );
};

const TableInfoBar: React.FC<TableInfoBarProps> = ({ title, rightContent, className }) => {
  return (
    <SectionInfoStyled className={className}>
      <TitleStyled>{title}</TitleStyled>
      {rightContent}
    </SectionInfoStyled>
  );
};

export default TableInfoBar;
